module.exports = __webpack_public_path__ + "img/header-overlay.d6aa5f90.png";